import { Image, SkeletonNode } from "@/base/components/index";
import { cx } from "antd-style";
import { useEffect, useRef, useState } from "react";
import ImageDefaultSvg from "../static/image-default.svg";
import { ProductImageProps } from "../types/index";
import { useProductImageStyles } from "./product-image.styles";

export const ProductImage = ({
  src,
  className,
  rootClassName,
  width,
  height,
  ...imageProps
}: ProductImageProps) => {
  const { styles } = useProductImageStyles();
  const containerRef = useRef<HTMLDivElement>(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const element = containerRef.current;
    if (!element) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.disconnect();
        }
      },
      { threshold: 0.1 },
    );

    observer.observe(element);

    return () => observer.disconnect();
  }, []);

  return (
    <div
      ref={containerRef}
      className={cx(styles.root, rootClassName)}
      style={{ width, height }}
    >
      <Image
        src={isVisible ? src : undefined}
        preview={false}
        fallback={ImageDefaultSvg}
        className={cx(className)}
        rootClassName={cx(styles.image)}
        placeholder={<SkeletonNode active rootClassName={styles.skeleton} />}
        {...imageProps}
      />
    </div>
  );
};
